import { STATUS_ORDERS, TAB_ORDERS } from 'components/pages/orders/base/enumsOrders';
import { CONST, STATUS_INVOICES, TAB_INVOICES_N_SUPPLIERS } from 'constants/enums';
import { template } from 'utils/helper';
import { getWindowOptions } from 'utils/hooks/storage/storageGets';

export const url_invoices = {
	settle_excess_invoice: template`invoices/${'slug'}/settle-excess-invoice/`,
	settle_excess_invoices: 'invoices/settle-excess-invoices/',
	update_final_order_account_number: template`invoices/${'slug'}/update-final-order-account-number/`,
	clear: 'invoices/clear/',
	orders_slug_clear_manually: template`invoices/orders/${'slug'}/clear-manually/`,
	orders_change_status: 'invoices/orders/change-status/',
	order: template`invoices/orders/${'slug'}/`,
	orders: 'invoices/orders/',
	import: 'invoices/import/',
	check_account_number: template`invoices/${'id'}/check-account-number/`,
	change_status: 'invoices/change-status/',
	restore_to_edit: 'invoices/restore/',
	publish: 'invoices/publish/',
	unpublished: template`invoices/unpublished/${'slug'}/`,
	delete: 'invoices/delete/',
	create: 'invoices/create/',
	dashboard: 'invoices/dashboard/count/',
	dashboardSummary: 'reports/dashboard/summary/',
	dashboardBankAccounts: 'banks/dashboard/accounts/',
	object: template`invoices/${'slug'}/`,
	list: 'invoices/'
};

const invoices = service => ({
	settleExcessInvoice: ({ slug, ...formParams }) => service.put(url_invoices.settle_excess_invoice({ slug }), formParams),
	settleExcessInvoices: ({ idsInvoices, realizedOutsideSystem }) => service.put(url_invoices.settle_excess_invoices, { invoices: idsInvoices, realizedOutsideSystem }),
	changeBillToDefault: ({ slug }) => service.put(url_invoices.update_final_order_account_number({ slug })),
	settle: ({ invoices }) => service.put(url_invoices.clear, { invoices }),
	clearManually: ({ slug, values }) => service.put(url_invoices.orders_slug_clear_manually({ slug }), { comment: values.comment }),
	changeStatusOrders: ({ status, ids }) => service.put(url_invoices.orders_change_status, {
		status,
		orders: ids
	}),
	getOrder: ({ slug }) => service.get(url_invoices.order({ slug })),
	getOrders: ({ agreementSlug, page, rowsPerPage, currentTab, searchParameter, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const tab = currentTab || TAB_ORDERS.CREATED;

		const defaultOrder = {
			[TAB_ORDERS.NONE]: {},
			[TAB_ORDERS.ALL]: { o: '-createdDate' },
			[TAB_ORDERS.WITHOUT_PAYMENT]: { o: '-createdDate' },
			[TAB_ORDERS.CREATED]: { o: '-createdDate' },
			[TAB_ORDERS.PAID]: { o: '-modifiedDate' },
			[TAB_ORDERS.REALIZED]: { o: '-modifiedDate' },
			[TAB_ORDERS.INVOICED]: { o: '-modifiedDate' },
			[TAB_ORDERS.CLEARED]: { o: '-clearedDate' },
			[TAB_ORDERS.FINAL_ORDER]: { o: '-modifiedDate' },
			[TAB_ORDERS.GROUP]: { o: '-createdDate' },
			[TAB_ORDERS.ARCHIVE]: { o: '-createdDate' },
			[TAB_ORDERS.FOR_INVOICING]: { o: '-createdDate' },
			[TAB_ORDERS.NETWORK_PROCESSING]: { o: '-createdDate' }
		};

		const pagination = Object.assign({},
			order ? { o: order } : defaultOrder[tab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		const otherParams = Object.assign({},
			searchParameter && { q: searchParameter },
			agreementSlug && (agreementSlug !== CONST.ALL_SLUG_ROUTE) && { agreement: agreementSlug },
		);

		const filters = {
			[TAB_ORDERS.NONE]: { ...pagination },
			[TAB_ORDERS.ALL]: { ...pagination },
			[TAB_ORDERS.WITHOUT_PAYMENT]: { ...pagination, withoutPayment: 1 },
			[TAB_ORDERS.CREATED]: { ...pagination, status: STATUS_ORDERS.CREATED, grouped: 0 },
			[TAB_ORDERS.PAID]: { ...pagination, status: STATUS_ORDERS.GENERATED_TRANSFER, grouped: 0 },
			[TAB_ORDERS.REALIZED]: { ...pagination, status: STATUS_ORDERS.REALIZED, grouped: 0 },
			[TAB_ORDERS.INVOICED]: { ...pagination, status: STATUS_ORDERS.INVOICED, grouped: 0 },
			[TAB_ORDERS.CLEARED]: { ...pagination, status: STATUS_ORDERS.CLEARED, grouped: 0 },
			[TAB_ORDERS.FINAL_ORDER]: { ...pagination, final: 1, grouped: 0 },
			[TAB_ORDERS.GROUP]: { ...pagination, grouped: 1 },
			[TAB_ORDERS.ARCHIVE]: { ...pagination, status: STATUS_ORDERS.ARCHIVE },
			[TAB_ORDERS.FOR_INVOICING]: { ...pagination, forInvoicing: 1 },
			[TAB_ORDERS.NETWORK_PROCESSING]: { ...pagination, networkProcessing: 1 }

		};

		return service.get(url_invoices.orders, {
			params: {
				...filters[tab],
				...otherParams
			}
		});
	},
	getInvoicesBuffer: (uuid) => service.get(`invoices/buffer/${uuid}/`),
	getBufferCount: () => service.get('invoices/buffer/count/'),
	importInvoicesFromFile: ({ dataUri, agreement }) => {
		const formData = new FormData();
		formData.append('file', dataUri, dataUri.name);
		formData.append('agreement', agreement.slug);

		return service.post(url_invoices.import, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
	checkAccountNumber: (id, bankAccountNumber) => service.put(url_invoices.check_account_number({ id }), { bankAccountNumber }),
	changeInvoicesStatus: (idsInvoices, status) => service.put(url_invoices.change_status, { invoices: idsInvoices, status }),
	restoreToEdit: (idsInvoices) => service.put(url_invoices.restore_to_edit, { invoices: idsInvoices }),
	publicInvoices: (idsInvoices, publicationStart, publicationEnd, shouldPublishAll) => service.put('invoices/publish/',
		Object.assign({
			invoices: idsInvoices,
		},
		publicationStart && { publicationStart },
		publicationEnd && { publicationEnd },
		{ publishAll: shouldPublishAll }
		)
	),
	getErrorFile: (uuid) => {
		const params = {};

		return service.get(`invoices/import/${uuid}/error-file/`, params, {
			responseType: 'blob'
		});
	},
	publicInvoicesBuffer: ({ uuid, status }) => service.post(`invoices/buffer/${uuid}/`, { status }),
	updateInvoiceInBuffer: ({ slug, ...invoice }) => service.put(url_invoices.unpublished({ slug }), invoice),
	removeInvoices: (idsInvoices) => service.delete(url_invoices.delete, { data: { invoices: idsInvoices } }),
	createManualInvoices: ({ invoices, agreement }) => service.post(url_invoices.create, {
		agreement: agreement.slug,
		invoices
	}),
	getDashboardSummary: () => service.get(url_invoices.dashboardSummary),
	getDashboardBankAccounts: () => service.get(url_invoices.dashboardBankAccounts),
	getInvoicesDashboard: () => service.get(url_invoices.dashboard),
	getInvoice: ({ slug }) => service.get(url_invoices.object({ slug })),
	getInvoices: ({ agreementSlug, page, rowsPerPage, currentTab, searchParameter, sortParameter, isOrderByAsc, additionalSearchParameter, ...additionalParams }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();
		const tab = currentTab || TAB_INVOICES_N_SUPPLIERS.PUBLISHED;

		const defaultOrder = {
			[TAB_INVOICES_N_SUPPLIERS.NONE]: {},
			[TAB_INVOICES_N_SUPPLIERS.ALL]: { o: '-createdDate' },
			[TAB_INVOICES_N_SUPPLIERS.REGISTRY]: { o: '-createdDate' },
			[TAB_INVOICES_N_SUPPLIERS.PUBLISHED]: { o: '-publicationDate' },
			[TAB_INVOICES_N_SUPPLIERS.WAITING_ROOM]: { o: '-modifiedDate' },
			[TAB_INVOICES_N_SUPPLIERS.PAUSED]: { o: '-pausedDate' },
			[TAB_INVOICES_N_SUPPLIERS.EXPIRED]: { o: '-modifiedDate' },
			[TAB_INVOICES_N_SUPPLIERS.ARCHIVE]: { o: '-archiveDate' },
			[TAB_INVOICES_N_SUPPLIERS.NO_ACCOUNT]: { o: '-createdDate' },
			[TAB_INVOICES_N_SUPPLIERS.CLEARED]: { o: '-clearedDate' },
			[TAB_INVOICES_N_SUPPLIERS.CLEARED_FINAL_ORDER]: { o: '-clearedDate' }
		};

		const pagination = Object.assign({},
			{ pageSize: paginationLimitTable },
			order ? { o: order } : defaultOrder[tab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		const cpParams = { ...additionalParams };
		delete cpParams.month;
		delete cpParams.year;

		const otherParams = Object.assign(cpParams,
			searchParameter && { q: searchParameter },
			additionalSearchParameter && { animator: additionalSearchParameter },
			additionalParams?.month && { month: additionalParams?.month },
			additionalParams?.year && { year: additionalParams?.year },
			agreementSlug && (agreementSlug !== CONST.ALL_SLUG_ROUTE) && { agreement: agreementSlug },
		);

		const filters = {
			[TAB_INVOICES_N_SUPPLIERS.NONE]: {},
			[TAB_INVOICES_N_SUPPLIERS.ALL]: {},
			[TAB_INVOICES_N_SUPPLIERS.REGISTRY]: {},
			[TAB_INVOICES_N_SUPPLIERS.PUBLISHED]: { status: STATUS_INVOICES.PUBLISHED },
			[TAB_INVOICES_N_SUPPLIERS.WAITING_ROOM]: { status: STATUS_INVOICES.WAITING_ROOM },
			[TAB_INVOICES_N_SUPPLIERS.PAUSED]: { status: STATUS_INVOICES.PAUSED },
			[TAB_INVOICES_N_SUPPLIERS.EXPIRED]: { status: STATUS_INVOICES.EXPIRED },
			[TAB_INVOICES_N_SUPPLIERS.ARCHIVE]: { status: STATUS_INVOICES.ARCHIVE },
			[TAB_INVOICES_N_SUPPLIERS.NO_ACCOUNT]: { haveBankAccount: 0 },
			[TAB_INVOICES_N_SUPPLIERS.CLEARED]: { status: STATUS_INVOICES.CLEARED },
			[TAB_INVOICES_N_SUPPLIERS.CLEARED_FINAL_ORDER]: { status: STATUS_INVOICES.CLEARED_FINAL_ORDER }
		};

		return service.get(url_invoices.list, {
			params: {
				...pagination,
				...filters[tab],
				...otherParams
			}
		});
	}
});

export default invoices;
